var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:(!_vm.flat===true)?'map-container':'flat-map'},[_c('gmap-map',{staticClass:"map-zone",attrs:{"center":_vm.center,"zoom":16,"options":_vm.mapOptions}},[_c('GmapMarker',{attrs:{"position":_vm.marker,"clickable":true,"draggable":false},on:{"click":function($event){_vm.center=_vm.marker}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }